export default __webpack_public_path__ + "static/media/decada-0080-0007-min.64994162.jpg";